"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const GridConstants_1 = tslib_1.__importDefault(require("./GridConstants"));
class GridSelectionState {
    constructor(grid) {
        this.shiftSelectOrigin = null;
        this.grid = grid;
        this.selectedRows = [];
        grid.addClickHandler((event) => {
            if (this.rowClicked(event)) {
                event.preventDefault();
            }
        });
        grid.addGridChangedListener(this);
    }
    clearSelected() {
        const selected = [...this.selectedRows];
        for (let tr of selected) {
            this.deselect(tr);
        }
    }
    select(tr) {
        const firstTR = this.grid.getRelatedElements(tr);
        if (this.selectedRows.indexOf(firstTR) === -1) {
            this.selectedRows.push(firstTR);
            firstTR?.classList.add(GridConstants_1.default.GRID_ROW_SELECTED);
        }
    }
    deselect(tr) {
        const firstTR = this.grid.getRelatedElements(tr);
        if (this.selectedRows.indexOf(firstTR) > -1) {
            this.selectedRows.splice(this.selectedRows.indexOf(firstTR), 1);
            firstTR?.classList.remove(GridConstants_1.default.GRID_ROW_SELECTED);
        }
    }
    isSelected(tr) {
        return this.selectedRows.indexOf(tr) > -1;
    }
    getSelected() {
        return [...this.selectedRows];
    }
    gridChanged() {
        this.selectedRows = [];
    }
    rowClicked(event) {
        const cell = this.grid.getElementForEvent(event);
        if (cell && "td" === cell.nodeName.toLowerCase()) {
            const tr = cell.parentElement;
            if (tr?.classList.contains(GridConstants_1.default.GRID_ROW_EXPAND_EXPANDED)) {
                return false;
            }
            const ctrlKey = event.ctrlKey;
            const shiftKey = event.shiftKey;
            if (ctrlKey) {
                if (this.isSelected(tr)) {
                    this.deselect(tr);
                }
                else {
                    this.select(tr);
                }
                this.shiftSelectOrigin = tr;
            }
            else if (shiftKey) {
                this.clearSelected();
                const row = this.getRowForTR(tr);
                let shiftSelectOriginRow = this.shiftSelectOrigin ? this.getRowForTR(this.shiftSelectOrigin) : 0;
                if (row > shiftSelectOriginRow) {
                    this.selectRows(this.shiftSelectOrigin, tr);
                }
                else {
                    this.selectRows(tr, this.shiftSelectOrigin);
                }
            }
            else {
                this.clearSelected();
                this.select(tr);
                this.shiftSelectOrigin = tr;
            }
            return true;
        }
        return false;
    }
    getRowForTR(tr) {
        const body = tr.parentElement;
        return fmko_ts_common_1.DOM.indexOf(body, tr);
    }
    selectRows(firstRow, lastRow) {
        this.select(firstRow);
        let row = firstRow;
        while (row !== lastRow) {
            row = row.nextElementSibling;
            this.select(row);
        }
    }
}
exports.default = GridSelectionState;
//# sourceMappingURL=GridSelectionState.js.map